<template>
    <div class="container" id="container">

        <!-- Buttin Back  -->
        <div class="btn-back">
            <button @click="goBack()" class="btn btn--white">
                <svg class="mr-2 display-table-cell" width="5" height="9" viewBox="0 0 5 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 0.594098V8.22252C5 8.75074 4.36135 9.01526 3.98785 8.64176L0.173647 4.82755C-0.0578822 4.59602 -0.0578822 4.2206 0.173647 3.98907L3.98785 0.174856C4.36135 -0.198674 5 0.06588 5 0.594098Z" fill="#52749C"/></svg>
                <span>Back</span>
            </button>
        </div>

        <!-- Header -->
        <div class="launchpad__header display-table mb-4 w-100 position-relative">
          <svg class="launchpad__header--icon display-table-cell" width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.8393 0.5625C6.19596 0.5625 0 6.8584 0 14.625C0 17.2031 0.684756 19.6182 1.87695 21.6953C2.14653 22.165 2.66022 22.4375 3.19553 22.4375H24.483C25.0184 22.4375 25.532 22.165 25.8016 21.6953C26.9938 19.6182 27.6786 17.2031 27.6786 14.625C27.6786 6.8584 21.4826 0.5625 13.8393 0.5625ZM21.6815 9.07861L16.4654 16.1455C16.7446 16.6157 16.9147 17.1606 16.9147 17.75C16.9147 18.3223 16.7523 18.8511 16.488 19.3125H11.1906C10.9263 18.8511 10.7639 18.3223 10.7639 17.75C10.7639 16.0239 12.1406 14.625 13.8393 14.625C14.1108 14.625 14.3688 14.6719 14.6197 14.7393L19.8363 7.67139C20.2198 7.15576 20.9415 7.05029 21.4514 7.43701C21.9603 7.82568 22.064 8.56055 21.6815 9.07861Z" fill="#2B4D75"/>
          </svg>
          <div class="ml-2 launchpad__header--title display-table-cell">
            <div class="display-table">
              <h1 v-if="details && details.name" class="m-0 header display-table-cell">{{details.name}}</h1>
              <button class="btn btn--white display-table-cell ml-4" :class="loadingGetDataPixel?'disabled':''" @click="showPixelModal()">
                <span v-if="!loadingGetDataPixel">Show Pixel</span>
                <s-loader v-else></s-loader>
              </button>
            </div>
          </div>
        </div>

        <!-- Task Table -->
        <div id="products-table">
          <s-card class="products-table__card border-top-0 p-0">
            <s-card-header v-if="details" class="font-weight-bold">
              <div class="display-table "  style="width: calc(100% - 500px) !important;">
                <img class="display-table-cell" v-if="details.status=='Done'" src="../../assets/images/status/success.svg" alt="">
                <img class="display-table-cell" v-else-if="details.status=='Failed' || details.status=='Deleted'" src="../../assets/images/status/danger.svg" alt="">
                <img class="display-table-cell" v-else-if="details.status=='Stopped' || details.status=='Pending'" src="../../assets/images/status/warning.svg" alt="">
                <img class="display-table-cell" v-else src="../../assets/images/status/secondary.svg" alt="">
                <span class="display-table-cell pl-2">{{details.status}}</span>
                <p class="pl-2 text-danger font-weight-bold " v-if="details.error" :tooltip="JSON.parse(details.error)['message']">{{JSON.parse(details.error)['message']}}</p>
              </div>
              <div class="text-right display-inline-block" style="width: 500px !important;">
                <button @click="playTask()" class="btn btn--white" :class="loadingPlay?'disabled':''">
                  <span v-if="!loadingPlay">Play</span>
                  <s-loader v-else></s-loader>
                </button>
                <button @click="stopTask()" class="btn btn--white ml-2" :class="loadingStope?'disabled':''">
                  <span v-if="!loadingStope">Stop</span>
                  <s-loader v-else></s-loader>
                </button>
                <button @click="retryTask()" class="btn btn--white ml-2" :class="loadingRetry?'disabled':''">
                  <span v-if="!loadingRetry">Retry</span>
                  <s-loader v-else></s-loader>
                </button>
                <button @click="archiveTask()" class="btn btn--white ml-2" :class="loadingArchive?'disabled':''">
                  <span v-if="!loadingArchive">Archive</span>
                  <s-loader v-else></s-loader>
                </button>
                <button @click="deleteTask()" class="btn btn--white ml-2" :class="loadingDelete?'disabled':''">
                  <span v-if="!loadingDelete">Delete</span>
                  <s-loader v-else></s-loader>
                </button>
                <!-- <button @click="tryAgainTask()" class="btn btn--white ml-2">Try again</button>
                <button @click="editJson()" class="btn btn--primary ml-2">Edit JSON</button> -->
              </div>
            </s-card-header>
            <s-card-body v-if="details && details.actions && details.actions.length > 0" class="product-table__table p-0">
                <div class="product-table__table-container">
                    <table  class="product-table__table--table" style="width: 1160px;" id="myTable">
                        <thead class="product-table__table--header border-0 p-0 mb-4">
                            <!-- Name -->
                            <td style="width:400px" class="text-truncate product-table__table--header-domain">
                                <span>Name</span>
                            </td>
                            <!-- Status -->
                            <td class="text-truncate product-table__table--header-joined">
                                <span>Status</span>
                            </td>
                            <!-- Error -->
                            <td style="width:400px" class="text-truncate product-table__table--header-domain">
                                <span>Error</span>
                            </td>
                            <!-- Edit Json -->
                            <td class="text-truncate product-table__table--header-joined">
                                <span>Edit Json</span>
                            </td>
                        </thead>
                        <tbody class="product-table__table--body">
                            <tr v-for="(action, actionIndex) in details.actions" :key="actionIndex" class="product-table__table--row">
                                <!-- Name -->
                                <td :tooltip-position="actionIndex==0?'right':'top'" :tooltip="action.settings.fb_settings && action.settings.fb_settings.prefix ? action.settings.fb_settings.prefix : action.settings.fb_settings.name ? action.settings.fb_settings.name : ' '" style="width:400px" class="product-table__table--body-domain">
                                  <p class="text-truncate">{{action.settings.fb_settings && action.settings.fb_settings.prefix ? action.settings.fb_settings.prefix : action.settings.fb_settings.name ? action.settings.fb_settings.name : " "}}</p>
                                </td>
                                <!-- Status -->
                                <td class="product-table__table--body-joined">
                                  <div class="display-table w-100">
                                    <img class="display-table-cell" v-if="action.status == 1" src="../../assets/images/status/success.svg" alt="">
                                    <img class="display-table-cell" v-else-if="action.status == -1 " src="../../assets/images/status/danger.svg" alt="">
                                    <img class="display-table-cell" v-else-if="action.status == 0 " src="../../assets/images/status/warning.svg" alt="">
                                    <img class="display-table-cell" v-else src="../../assets/images/status/secondary.svg" alt="">
                                    <p class="pl-2 text-truncate">{{action.status == 0 ? "Pending" : action.status == 1 ? "Created" : action.status == -1 ? "Failed" : ""}}</p>
                                  </div>
                                </td>
                                <!-- Error -->
                                <td :tooltip="action && action.error && action.error.error_user_msg ? action.error.error_user_msg : action && action.error && action.error.error_user_title ? action.error.error_user_title : action && action.error && action.error.message ? action.error.message : ''" :tooltip-position="actionIndex==0?'bottom':'top'" style="width:400px" class="product-table__table--body-domain">
                                  <p class="text-truncate">{{action && action.error && action.error.error_user_msg ? action.error.error_user_msg : action && action.error && action.error.error_user_title ? action.error.error_user_title : action && action.error && action.error.message ? action.error.message : ''}}</p>
                                </td>
                                <!-- Edit JSON -->
                                <td class="product-table__table--body-joined">
                                  <button @click="editJson(actionIndex)" class="btn btn--primary ml-2">Edit JSON</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </s-card-body>
            <s-card-body v-else class="p-3 text-center">
              Loading || No Data
            </s-card-body>
          </s-card>
        </div>

        <!-- JSON Editor -->
        <div v-if="jsonEditor" style="background: rgba(13, 35, 62, 0.94); height: 100%; width: 100%; position: fixed; top: 0; left: 0;z-index: 13;">
          <s-card style="width: 90%; position: absolute; transform: translate(-50%,-50%); left: 50%; top: 50%;">
            <s-card-header class="font-weight-bold">JSON Action Editor</s-card-header>
            <s-card-body class="p-3">
              <div class="border" style="min-height: 450px;">
                <v-jsoneditor ref="editor" v-model="modalCurrentAction" :options="{mode: 'code'}" height="450px" :plus="false"  @error="onError"></v-jsoneditor>
              </div>
            </s-card-body>
            <s-card-footer class="text-right">
              <button @click="jsonEditor = false;modalCurrentAction=null" class="btn btn--white">Cancel</button>
                <button @click="saveJSON()" class="btn btn--primary ml-2">Save</button>
            </s-card-footer>
          </s-card>
        </div>

        <!-- Pixel Data -->
        <div v-if="modalPixel" style="background: rgba(13, 35, 62, 0.94); height: 100%; width: 100%; position: fixed; top: 0; left: 0;z-index: 13;">
          <s-card style="width: 90%; position: absolute; transform: translate(-50%,-50%); left: 50%; top: 50%;">
            <s-card-header class="font-weight-bold position-relative">
              <span>Pixel Data</span>
              <svg @click="modalPixel = false" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%); cursor: pointer;" width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="3.53552" width="5" height="40" rx="2.5" transform="rotate(-45 0 3.53552)" fill="#C6D9FF"/>
                <rect x="3.53564" y="31.8198" width="5" height="40" rx="2.5" transform="rotate(-135 3.53564 31.8198)" fill="#C6D9FF"/>
              </svg>
            </s-card-header>
            <s-card-body class="p-3">
              <div class="border" style="min-height: 450px;">
                <v-jsoneditor ref="pixel" v-model="pixelData" :options="{mode: 'code'}" height="450px" :plus="false"  @error="onError"></v-jsoneditor>
              </div>
            </s-card-body>
            <s-card-footer class="text-right">
              <button @click="modalPixel = false" class="btn btn--white">Cancel</button>
            </s-card-footer>
          </s-card>
        </div>

    </div>
</template>

<script>

import VJsoneditor from 'v-jsoneditor/src/index'

export default {

  name: 'task-details',

    components: {
      VJsoneditor
    },

    data(){
      return{
        details:null,
        modalCurrentAction: null,
        disableExtendTrial: false,
        jsonEditor: false,
        loadingPlay: false,
        loadingStope: false,
        loadingRetry: false,
        loadingArchive: false,
        loadingDelete: false,
        modalPixel: false,
        loadingGetDataPixel: false,
        pixelData: null
      };
    },
    async mounted(){

      if (this.$route.params && this.$route.params.id) {
        const getDetails = await this.taskDetails(`${this.api}/api/admin/task/${this.$route.params.id}/details`);
        console.log('getDetails: ', getDetails);
        if (getDetails && getDetails.id) {
          this.details = getDetails;
        }
      }

    },
    created(){

    },
    watch:{

    },
    methods:{
      async showPixelModal(){
        this.loadingGetDataPixel = true;
        let pixel = null
        for (let indexData = 0; indexData < this.details.actions.length; indexData++) {
          const action = this.details.actions[indexData];
          if (action && action.settings && action.settings.fb_settings && action.settings.fb_settings.promoted_object && action.settings.fb_settings.promoted_object.pixel_id) {
            pixel = action.settings.fb_settings.promoted_object.pixel_id
            break;
          }
        }
        if (pixel) {
          const pixelData = await this.getData(`${this.api}/api/admin/profile/${this.details.data.profile_id}/pixel/${pixel}/stats`);
          console.log('pixelData: ', pixelData);
          if (pixelData && pixelData.stats && pixelData.stats.data.length > 0) {
            this.pixelData = pixelData.stats.data;
            this.modalPixel = true;
          }else{
            this.notify("error","No pixel Exist")
          }
        }else{
          this.notify("error","No pixel Exist")
        }
        this.loadingGetDataPixel = false;
      },
      goBack(){
        if (this.$route.name == "account-task-details") {
          this.$router.push(`/account/${this.details.account_id}`);
        }else if (this.$route.name == "tasks-task-details"){
          this.$router.push(`/tasks`);
        }
      },
      async playTask(){
        if(confirm("Do you really want to play Task?")){
          this.loadingPlay = true;
          const play = await this.getData(`${this.api}/api/admin/task/${this.details.id}/play`);
          if (play && play.status == "success") {
            location.reload();
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingPlay = false
        }
      },
      async stopTask(){
        if(confirm("Do you really want to stop Task?")){
          this.loadingStope = true;
          const stop = await this.getData(`${this.api}/api/admin/task/${this.details.id}/stop`);
          if (stop && stop.status == "success") {
            location.reload();
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingStope = false
        }
      },
      async retryTask(){
        if(confirm("Do you really want to retry Task?")){
          this.loadingRetry = true;
          const retry = await this.getData(`${this.api}/api/admin/task/${this.details.id}/retry`);
          if (retry && retry.status == "success") {
            location.reload();
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingRetry = false
        }
      },
      async archiveTask(){
        if(confirm("Do you really want to archive Task?")){
          this.loadingArchive = true;
          const archive = await this.getData(`${this.api}/api/admin/task/${this.details.id}/archive`);
          if (archive && archive.status == "success") {
            this.$router.push('/tasks')
            location.reload();
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingArchive = false
        }
      },
      async deleteTask(){
        if(confirm("Do you really want to delete Task?")){
          this.loadingDelete = true;
          const deleteT = await this.getData(`${this.api}/api/admin/task/${this.details.id}/delete`);
          if (deleteT && deleteT.status == "success") {
            this.$router.push('/tasks')
            location.reload();
          }else{
            this.notify("error","Something went wrong, please try again")
          }
          this.loadingDelete = false
        }

      },
      editJson(index){
        this.modalCurrentAction = this.details.actions[index]
        this.jsonEditor = true;
      },
      async saveJSON(){
        let data = this.$refs.editor.editor.get()['settings'];
        const editAction = await this.editTaskAction(`${this.api}/api/admin/action/${this.modalCurrentAction.id}/edit`, data);
        if (editAction && editAction.status == "success") {
          location.reload();
        }else{
          this.notify("error","Something went wrong, please try again")
        }
      },
      onError() {
        console.log('error')
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .jsoneditor-poweredBy{
    display: none !important;
  }

</style>